<template>

<div>

  <LDBsTable
    url="model"
    defaultSort="name"
    defaultOrder="asc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-6">
      <label for="active_type">{{ $t('active_type') }}</label>
      <Combobox
        class="bg-white"
        name='active_type'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="activestypes"
        v-model="query.activeType"
        :reduce="activeType => activeType.id"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="model">{{ $t('model') }}</label>
      <input
        type="text"
        id="model"
        name="model"
        class="form-control"
        :placeholder="$t('ph_model')"
        v-model="query.name"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="manufacturer">{{ $t('manufacturer') }}</label>
      <Combobox
        class="bg-white"
        name='manufacturer'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="manufacturers"
        v-model="query.manufacturer"
        :reduce="manufacturer => manufacturer.id"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="canLinkSimcard">{{ $t('can_link_simcard') }}</label>
      <Combobox
        class="bg-white"
        name='canLinkSimcard'
        :placeholder="$t('select_a_item')"
        label="label"
        :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false } ]"
        v-model="query.canLinkSimcard"
        :reduce="model => model.value"
      />
    </div>

    <div class="form-group col-lg-6">
      <label for="isActive">{{ $t('active') }}</label>
      <Combobox
        class="bg-white"
        name='isActive'
        :placeholder="$t('select_a_item')"
        label="label"
        :options="[{ label: 'SIM', value: true }, { label: 'NÃO', value: false } ]"
        v-model="query.isActive"
        :reduce="model => model.value"
      />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'

export default {
  name: 'ModelList',
  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('active_type'),
          field: 'activeType',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('model'),
          field: 'name',
          sortable: true
        },
        {
          title: this.$t('manufacturer'),
          field: 'manufacturer',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('can_link_simcard'),
          field: 'canLinkSimcard',
          formatter: function (value) {
            return value ? 'SIM' : 'NÃO'
          },
          sortable: true
        },
        {
          title: this.$t('active'),
          field: 'isActive',
          formatter: function (value) {
            return value ? 'SIM' : 'NÃO'
          },
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/model/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'modelos' }
      },
      query: {
        id: '',
        name: '',
        manufacturer: '',
        canLinkSimcard: '',
        isActive: '',
        activeType: undefined
      },
      queryToUse: {}
    }
  },

  computed: {
    ...mapState({
      manufacturers: state => state.manufacturer.all,
      activestypes: state => state.activestype.all,
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    clear() {
      this.query.name = ''
      this.query.manufacturer = ''
      this.query.canLinkSimcard = ''
      this.query.isActive = ''
      this.query.activeType = undefined
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['model'] ? this.lastquery['model'] : this.query
  },

  async mounted () {
    const { dispatch } = this.$store
    await dispatch('manufacturer/fetchAll')
    await dispatch('activestype/fetchAll')

    if (this.lastquery['model']) {
      for (const [key, value] of Object.entries(this.lastquery['model'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('manufacturer/cleanState')
    dispatch('activestype/cleanState')
    dispatch('filtershistory/setQuery', { key: 'model', query: this.query })
  }
}
</script>
